import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';
import { AbstractChart } from 'containers/charts/AbstractChart';

class TimeOfDayHeatMapChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data);
    }

    render() {
        const { data, categories, title } = this.props;
        const { chartRef } = this;

        const series = [{
            name: title,
            borderWidth: 1,
            data,
            dataLabels: {
                enabled: false,
            }
        }];

        const colorAxis = {
            reversed: false,
            min: 0,
            stops: [
                [0, '#007DC6'],
                [0.5, '#D04328'],
                [1, '#FBAD19']
            ]
        };

        const legend = {
            title: {
                text: '# Events'
            },
            align: 'right',
            layout: 'vertical',
            margin: 0,
            verticalAlign: 'top',
            y: 25,
            symbolHeight: 280
        };

        const tooltip = {
            formatter() {
                return `Events:<b> ${this.point.value}</b><br>Hour:<b> ${this.series.xAxis.categories[this.point.x]}</b><br><b>${this.series.yAxis.categories[this.point.y]}</b>`;
            }
        };

        const xAxis = {
            categories: categories.x,
            visible: true
        };

        const yAxis = {
            categories: categories.y,
            title: null,
            visible: true
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart')}>
                <ContentHeader type={'chart'} chartRef={chartRef}>{title}</ContentHeader>
                <AbstractChart exportName={this.props.exportName}
                    ref={chartRef}
                    config={{
                        meta: {
                            title
                        },
                        chart: {
                            type: 'heatmap'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        colorAxis,
                        tooltip,
                        legend,
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

TimeOfDayHeatMapChart.propTypes = {
    data: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    categories: PropTypes.shape({
        x: PropTypes.array.isRequired,
        y: PropTypes.array.isRequired
    }).isRequired,
    exportName: PropTypes.string.isRequired
};

export default TimeOfDayHeatMapChart;



// WEBPACK FOOTER //
// ./src/components/molecules/charts/TimeOfDayHeatMapChart.js